'use client';

import { c as _c } from "react/compiler-runtime";
import { useAdminCmdK } from '@repo/shortcuts/admin';
import type { CommandWorkflow, CommandWorkflowActionNode } from '@repo/shortcuts/command';
import { useGlobalShortcut } from './_hooks/use-global-shortcut.ts';
import { LOAD_DUPLICATE_COMMAND_ID } from './load-commands.tsx';
const noop = () => undefined;
const findRootAction = <PageId extends string,>(workflow: CommandWorkflow<PageId>, id: string) => workflow.pages[workflow.rootPageId].groups.flatMap(group => group.items).find((node): node is CommandWorkflowActionNode<PageId> => node.kind === 'action' && node.id === id);
export const ScopedCmdKShortcuts = t0 => {
  const $ = _c(18);
  const {
    workflow
  } = t0;
  const {
    open
  } = useAdminCmdK();
  let t1;
  if ($[0] !== workflow) {
    t1 = findRootAction(workflow, LOAD_DUPLICATE_COMMAND_ID);
    $[0] = workflow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const duplicateLoad = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["L", "S"];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== open) {
    t3 = () => open("load-status");
    $[3] = open;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== workflow.pages) {
    t4 = Object.hasOwn(workflow.pages, "load-status");
    $[5] = workflow.pages;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useGlobalShortcut(t2, t3, t4);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["C", "X"];
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== open) {
    t6 = () => open("company-xero");
    $[8] = open;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== workflow.pages) {
    t7 = Object.hasOwn(workflow.pages, "company-xero");
    $[10] = workflow.pages;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  useGlobalShortcut(t5, t6, t7);
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["L", "D"];
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== duplicateLoad || $[14] !== open || $[15] !== workflow.pages || $[16] !== workflow.rootPageId) {
    t9 = () => void duplicateLoad?.onSelect({
      close: noop,
      currentPage: workflow.pages[workflow.rootPageId],
      currentPageId: workflow.rootPageId,
      goBack: noop,
      goTo: open,
      goToPage: noop,
      resetWorkflow: noop,
      search: "",
      setSearch: noop
    });
    $[13] = duplicateLoad;
    $[14] = open;
    $[15] = workflow.pages;
    $[16] = workflow.rootPageId;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  useGlobalShortcut(t8, t9, duplicateLoad !== undefined && !duplicateLoad.disabled);
  return null;
};